const SmartNFTs = () => {
  return <div>SmartNFTs</div>;
};

export default SmartNFTs;
